export default __webpack_public_path__ + "static/media/dot.d1979055.svg";